<template>
	<div
		class="tab-pill"
		:class="[`direction-${direction}`]"
		:style="{
			left: `${position.left}px`,
			right: `${position.right}px`,
			top: `${position.top}px`,
			height: `${position.height}px`,
		}"
		v-if="position"
	></div>
</template>

<script>
export default {
	name: 'TabPill',
	props: {
		tab: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			position: null,
			direction: 'right',
		}
	},
	watch: {
		tab() {
			this.$nextTick(() => {
				this.getPositions()
			})
		},
	},
	methods: {
		getPositions() {
			const activeTabElement = this.$parent.$el.querySelector('.tab.active')
			if (this.position && activeTabElement.offsetLeft > this.position.left) {
				this.direction = 'right'
			} else {
				this.direction = 'left'
			}
			this.position = {
				left: activeTabElement.offsetLeft,
				right: this.$parent.$el.offsetWidth - activeTabElement.offsetWidth - activeTabElement.offsetLeft,
				top: activeTabElement.offsetTop,
				height: activeTabElement.offsetHeight,
			}
		},
	},
	mounted() {
		this.getPositions()
		window.addEventListener('resize', this.getPositions)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.getPositions)
	},
}
</script>

<style lang="scss" scoped>
.tab-pill {
	position: absolute;
	box-shadow: 0 0 4px theme-color(900, 0.25), 0 2px 12px theme-color(800, 0.4);
	background-color: white;
	background-image: linear-gradient(#{theme-color(100, 0.1)}, #{theme-color(100, 0)});
	border-radius: 1rem;
	transition: left 0.2s $ease-in-out-quad 0.06s, right 0.2s $ease-in-out-quad;

	&.direction-left {
		transition: left 0.2s $ease-in-out-quad, right 0.2s $ease-in-out-quad 0.06s;
	}
}
</style>
